export default __webpack_public_path__ + "static/media/instaLogo.0c3379ce.png";